import styled from 'styled-components';
import { EXCHANGE_COLLATERAL_SUCCESS_BG } from '../../config/media';

export default styled.div`
	.success-image {
		height: 522px;
		background-size: cover;
		background-repeat: no-repeat;
		background-image: url(${EXCHANGE_COLLATERAL_SUCCESS_BG});
		position: relative;
		overflow: hidden;
		video {
			width: 100%;
		}
		p {
			position: absolute;
			width: 100%;
			text-align: center;
			font-size: 24px;
			font-weight: bold;
			color: #fff;
		}
		.top {
			top: 65px;
		}
		.bottom {
			bottom: 47px;
		}
	}
	.collateral-info {
		display: flex;
		align-items: center;
		margin: 12px 0;
		> * {
			flex: 1;
		}
		img {
			width: 80px;
		}
		p {
			margin: 0;
			line-height: 22px;
		}
	}
	.disclamar {
		font-size: 10px;
		line-height: 1.4;
		text-align: center;
		color: #a9a9a9;
		margin-bottom: 22px;
	}
`;
